<!-- App Maintain Capsule -->
<div class="d-flex flex-column align-items-center">
  <img *ngIf="message.imageUrl == null"  src='./assets/img/maintenance.png' width="100px" height="100px" />
  <img width="80" height="80" [src]="message.imageUrl" class="gameTitleImgClass" *ngIf="message.imageUrl !=null">
  <p class="mt-2">{{message.description}}</p>
</div>
<!-- * App Maintain Capsule-->